import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import Button from "components/Button";
import {
  cancelOrder,
  submitOrderToCanada,
  submitOrderToUSA,
} from "actions/orders";

import { declineBlinkSwagOrder, blinkSwagOrderEvents } from "actions/orders";
import {
  Row,
  SubRow,
  RowHeader,
  RowFooter,
} from "styles/pages/smart-print-sink";

const regExpr = /[^a-zA-Z0-9- ]/g;

const OrbitkitModal = ({ onClose, open, data }) => {
  const token = useSelector((state) => state?.auth?.profile?.token);
  const dispatch = useDispatch();
  const [events, setEvents] = useState(null);

  useEffect(() => {
    (async () => {
      if (data?.order_data?.id && !events) {
        const response = await dispatch(
          blinkSwagOrderEvents({
            id: data?.order_data?.id,
          })
        );

        setEvents(response);
      }
    })();
  }, [data?.order_data?.id, dispatch]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ paddingBottom: 0 }}>
        <CloseIcon
          style={{ float: "right", cursor: "pointer", color: "#a1a1a1" }}
          onClick={onClose}
        />
      </DialogTitle>
      <DialogContent style={{ paddingTop: 0 }}>
        {!!data?.order_data?.items?.length &&
          data?.order_data?.items?.map((d, index) => {
            const design = d?.design;

            return (
              <Row key={index}>
                <RowHeader>
                  <span>SKU:{d?.sku}</span>
                  <span>Size:{d?.size}</span>
                  <span>Color:{d?.color}</span>
                </RowHeader>
                {!!design?.length &&
                  design?.map((x) => {
                    return (
                      <SubRow>
                        <img src={x?.thumb} alt="thumb" />
                        <div className="src">
                          <img src={x?.src_file} alt="src" />
                        </div>
                      </SubRow>
                    );
                  })}
              </Row>
            );
          })}

        <RowHeader>
          {data?.order_data?.address_to?.first_name}&nbsp;
          {data?.order_data?.address_to?.last_name}&nbsp;
          <br />
          {data?.order_data?.address_to?.address1}&nbsp;
          {data?.order_data?.address_to?.address2}&nbsp;
          <br />
          {data?.order_data?.address_to?.city}&nbsp;
          {data?.order_data?.address_to?.region}&nbsp;
          {data?.order_data?.address_to?.country}&nbsp;
          {data?.order_data?.address_to?.zip ||
            data?.order_data?.address_to?.postalCode}
        </RowHeader>

        <Stepper alternativeLabel activeStep={events?.length}>
          {events?.map((e) => (
            <Step key={e?.ction}>
              <StepLabel>
                {e?.action?.toUpperCase()}
                <br />
                {moment(e?.time).format("MMM DD,YYYY")}
                <br />
                {e?.tracking?.trackingNumber || ""}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <RowFooter style={{ display: "none" }}>
          {data?.Status !== "Declined" && data?.Status !== "Shipped" && (
            <Button
              className="declined"
              title="Decline"
              onClick={async () => {
                const payload = {
                  OrderNumber: data?.order_data?.id,
                  Status: "Declined",
                  Event: {
                    action: "declined",
                    time: moment().format("YYYY-MM-DD"),
                  },
                };
                await dispatch(declineBlinkSwagOrder(payload));
                await dispatch(
                  cancelOrder({
                    printProvider: data?.order_data?.print_provider,
                    source: "Admin",
                    orderId: `SPI-${data?.order_data?.id}`,
                  })
                );
                onClose();
              }}
            />
          )}
          {data?.Status !== "Approved" &&
            data?.Status !== "Processed" &&
            data?.Status !== "Shipped" && (
              <Button
                title="Approve"
                className="approve"
                onClick={async () => {
                  const payload = {
                    OrderNumber: data?.order_data?.id,
                    Status: "Approved",
                    Event: {
                      action: "approved",
                      time: moment().format("YYYY-MM-DD"),
                    },
                  };
                  await dispatch(declineBlinkSwagOrder(payload));

                  await dispatch(
                    declineBlinkSwagOrder({
                      OrderNumber: data?.order_data?.id,
                      Status: "Processed",
                      Event: {
                        action: "processed",
                        time: moment().format("YYYY-MM-DD"),
                      },
                    })
                  );

                  const printProvider = data?.order_data?.print_provider;
                  const shippingCountry = data?.order_data?.address_to?.country;
                  const orderId = data?.order_data?.id;

                  let items = "";

                  for (let i = 0; i < data?.order_data?.items.length; i++) {
                    const orderLineItem = data?.order_data?.items[i];
                    const printAreas = orderLineItem?.design;

                    items += `<Item>
                  <SKU>${orderLineItem?.sku.replace(regExpr, "")}</SKU>
                  <Descrip>[${orderLineItem?.type?.replace(
                    regExpr,
                    ""
                  )}] ${orderLineItem?.sku?.replace(regExpr, "")}</Descrip>
                  <Color>${orderLineItem.color?.replace(regExpr, "")}</Color>
                  <Qty>${orderLineItem.quantity}</Qty>
                  <Size>${orderLineItem.size?.replace(regExpr, "")}</Size>
                  <Type>${orderLineItem?.type?.replace(regExpr, "")}</Type>
                  <Style>${orderLineItem?.sku.replace(regExpr, "")}</Style>
                  <ProcessMode>Piece</ProcessMode>`;

                    for (let j = 0; j < printAreas?.length; j++) {
                      const row = printAreas[j];

                      items += `<Design>
                      <Location>${row?.location?.replace(
                        regExpr,
                        ""
                      )}</Location>
                      <Thumb>${row?.thumb}</Thumb>
                      <SourceFile>${row?.src_file?.replace(
                        ".jpg",
                        ".png"
                      )}</SourceFile>
                      <WhiteUnderbaseRequired>false</WhiteUnderbaseRequired>
                    </Design>`;
                    }

                    items += "</Item>";
                  }

                  const xml = `<AddXml xmlns="http://tempuri.org/">
                <OrderString>
                    <Request>
                        <CustID>1</CustID>
                        <PO>SPI-${orderId}</PO>
                        
                        <Source>Admin</Source>
                        <Store>Big Oven Tees</Store>
                        <StoreID>1</StoreID>
                        <ShipTo>
                            <FirstName>${data?.order_data?.address_to?.first_name?.replace(
                              regExpr,
                              ""
                            )}</FirstName>
                            <LastName></LastName>
                            <Company></Company>
                            <Adrx1>${data?.order_data?.address_to?.address1?.replace(
                              regExpr,
                              ""
                            )}</Adrx1>
                            <Adrx2>${data?.order_data?.address_to?.address2?.replace(
                              regExpr,
                              ""
                            )}</Adrx2>
                            <City>${data?.order_data?.address_to?.city?.replace(
                              regExpr,
                              ""
                            )}</City>
                            
                            <State>${data?.order_data?.address_to?.region?.replace(
                              regExpr,
                              ""
                            )}</State>
                            <Zip>${
                              data?.order_data?.address_to?.zip?.replace(
                                regExpr,
                                ""
                              ) ||
                              data?.order_data?.address_to?.postalCode?.replace(
                                regExpr,
                                ""
                              )
                            }</Zip>
                            <Country>${shippingCountry?.replace(
                              regExpr,
                              ""
                            )}</Country>
                            <Email></Email>
                        </ShipTo>
                        ${
                          printProvider === "CA"
                            ? `<ShipFrom>
                              <FirstName>Big Oven Tees</FirstName>
                              <LastName></LastName>
                              <Company>Big Oven Tees</Company>
                              <Adrx1>122 Middleton St.</Adrx1>
                              <Adrx2></Adrx2>
                              <City>Brantford</City>
                              <State>ON</State>
                              <Zip>N3S7V7</Zip>
                              <Country>CA</Country>
                              <Email>info@bigoventees.com</Email>
                            </ShipFrom>`
                            : `<ShipFrom>
                            <FirstName>Big Oven Tees</FirstName>
                            <LastName></LastName>
                            <Company>Big Oven Tees USA</Company>
                            <Adrx1>8742 Buffalo Avenue</Adrx1>
                            <Adrx2></Adrx2>
                            <City>Niagara Falls</City>
                            <State>NY</State>
                            <Zip>14304</Zip>
                            <Country>US</Country>
                            <Email>info@bigoventees.com</Email>
                          </ShipFrom>`
                        }
                        <ShipMethod>${
                          printProvider === "CA"
                            ? shippingCountry === "US"
                              ? "[Canada Post] Tracked Packet - USA"
                              : shippingCountry === "CA"
                              ? "[Canada Post] Expedited Parcel"
                              : "[Canada Post] Tracked Packet - International"
                            : "USPS First Class Mail"
                        }</ShipMethod>          
                        <ProductionPriority>Normal</ProductionPriority>
                        <Notes>Orbit Kit Order ${orderId}</Notes>
                        ${items}                        
                    </Request>
                </OrderString>
              </AddXml>`;

                  const response =
                    printProvider === "CA"
                      ? await dispatch(submitOrderToCanada(xml, token))
                      : await dispatch(submitOrderToUSA(xml, token));

                  onClose();
                }}
              />
            )}
        </RowFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OrbitkitModal;
